"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryTiles = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const Dropdown_1 = require("../controls/Dropdown");
const helpers_1 = require("../helpers");
const ToggleMenu_1 = require("../helpers/components/ToggleMenu/ToggleMenu");
const StackView_1 = require("../StackView");
const Tile_1 = require("../Tile");
const Svg = __importStar(require("./svg"));
const WrapperTile = styled_components_1.default.div ``;
const StyledSummaryTiles = styled_components_1.default.div `
    position: relative;
    display: flex;
    height: 128px;
    box-sizing: border-box;

    ${WrapperTile} {
        width: 100%;
        height: 100%;
        border-right: ${helpers_1.BASE_BORDER_WIDTH} solid ${({ theme }) => theme.colorBorderGrid};

        &:last-child {
            border-right: none;
        }
    }
`;
const MenuButton = react_1.default.forwardRef(({ className, onMouseDown }, ref) => {
    return (react_1.default.createElement("button", { className: className, ref: ref, onMouseDown: onMouseDown, "data-selector-id": "summarytiles-dropdown-control" },
        react_1.default.createElement(Svg.threeDots, null)));
});
const StyledMenuButton = (0, styled_components_1.default)(MenuButton) `
    display: flex;
    margin: 0 0 0 auto;
    width: ${helpers_1.SPACING_XL};
    height: ${helpers_1.SPACING_XL};
    border: none;
    background: none;
    padding: 0;
    align-items: center;

    &:active {
        outline: none;
    }

    ${({ theme }) => (0, styled_components_1.css) `
        &:hover {
            background: ${theme.colorHighlightLight};
        }
    `}

    ${({ isActive, theme }) => isActive &&
    (0, styled_components_1.css) `
            background: ${theme.colorHighlightDark};

            &:hover {
                background: ${theme.colorHighlightDark};
            }
        `}
`;
exports.SummaryTiles = (0, helpers_1.createUIElement)('SummaryTiles', (_a, ref) => {
    var { className, selectedItems, items, onChange, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "selectedItems", "items", "onChange", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    selectedItems = Array.from(new Set(selectedItems)) || [];
    const { getValue, setValue } = (0, helpers_1.useStateValue)(selectedItems, [selectedItems]);
    const updateValue = (id, isChecked) => {
        const currentValue = [...getValue()];
        const isIdSelected = currentValue.includes(id);
        if (!isChecked && isIdSelected) {
            return currentValue.filter((i) => i !== id);
        }
        if (isChecked && !isIdSelected) {
            currentValue.push(id);
        }
        return currentValue;
    };
    const handleChangeItem = (id, isChecked) => {
        const newValue = updateValue(id, isChecked);
        setValue(newValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
    };
    const options = [];
    const tiles = items &&
        items.map((_a, idx) => {
            var { id } = _a, tileProps = __rest(_a, ["id"]);
            const { title } = tileProps;
            const isChecked = getValue().includes(id);
            options.push(react_1.default.createElement(ToggleMenu_1.ToggleMenuItem, { key: `summarytiles-option-${idx}`, "data-selector-id": `summarytiles-option-${idx}`, title: title, isChecked: isChecked, onChange: (isChecked) => handleChangeItem(id, isChecked) }));
            return (isChecked && (react_1.default.createElement(WrapperTile, { key: `summarytiles-wrapper-tile${id}-${idx}` },
                react_1.default.createElement(Tile_1.Tile, Object.assign({ "data-selector-id": `summarytiles-wrapper-tile${idx}` }, tileProps)))));
        });
    return (react_1.default.createElement(StackView_1.StackView, Object.assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'summarytiles-wrapper', className: `vm-SummaryTiles ${className}`, direction: StackView_1.STACK_DIRECTION.column, gap: StackView_1.STACK_GAP.none, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        react_1.default.createElement(Dropdown_1.Dropdown, { renderControl: ({ button, isActive }) => (react_1.default.createElement(StyledMenuButton, Object.assign({}, button, { isActive: isActive }))), renderPopover: ({ popover, content }) => react_1.default.createElement("div", Object.assign({}, popover), content), renderContent: () => react_1.default.createElement(ToggleMenu_1.ToggleMenu, null, options) }),
        react_1.default.createElement(StyledSummaryTiles, null, tiles)));
});
//# sourceMappingURL=SummaryTiles.js.map